export { default } from './QuestionsAndAnswers';
